app.controller('aoaDownload', async function ($rootScope, $scope, $filter, safeApply, aoaService) {

  let aoa_processing_method
  let aoa_naming_convention
  let agent_id
  const aoaTable = '#aoa_management_table'
  const aoa_management_filelink_modal = 'aoa_management_filelink'
  $scope.displayMethod = 0
  $scope.currentCounty = { name: 'Collin', cad_code: '043' }

  $scope.setDisplayMethod = function (method) {
    $scope.displayMethod = method
    console.log('$scope.displayMethod :>> ', $scope.displayMethod);
    init()
  }

  $scope.setCounty = function (county) {
    $scope.currentCounty = { name: county.county, cad_code: county.cad_code, doc_count: county.doc_count }
    init()
  }

  // Pulls in user info from the rootScope -> CRMController
  $rootScope.$watch('user_info', function () {
    $scope.user_info = $rootScope.user_info
    console.log('$scope.user_info :>> ', $scope.user_info);
  }, true)

  init()
  async function init() {
    let results = await aoaService.loadAOAByCounty({ county: $scope.currentCounty.cad_code, displayMethod: $scope.displayMethod })
    console.log('results :>> ', results);

    const aoaData = results.data.data[0]
    const allCounties = results.data.data[1]
    $scope.countyList = results.data.data[2]
    console.log('$scope.countyList :>> ', $scope.countyList);

    const currentInList = $scope.countyList.find(c => c.cad_code == $scope.currentCounty.cad_code)
    $scope.currentCounty.doc_count = currentInList ? currentInList.doc_count : 0

    allCounties.forEach(county => {
      if (county.cad_code == $scope.currentCounty.cad_code) {
        aoa_processing_method = county.aoa_processing_method
        aoa_naming_convention = county.aoa_naming_convention
        agent_id = county.agent_id
      }
    })
    console.log('aoa_processing_method :>> ', aoa_processing_method);

    if ($.fn.dataTable.isDataTable(aoaTable)) {
      $(aoaTable).DataTable().destroy()
      $(aoaTable).empty()
      table = null
    }
    loadDataTable(aoaData)
  }

  function loadDataTable(aoaData) {
    let columns
    if ($scope.displayMethod == 0) {
      columns = [
        { title: "DOC ID", data: 'id', className: 'dt-body-center dt-head-center' },
        { title: "County", data: 'county', className: 'dt-body-left dt-head-left' },
        { title: "CAD Account", data: 'cad_account', className: 'dt-body-right dt-head-right' },
        { title: "User ID", data: 'user_id', className: 'dt-body-right dt-head-right' },
        { title: "First Name", data: 'first_name', className: 'dt-body-left dt-head-left' },
        { title: "Last Name", data: 'last_name', className: 'dt-body-left dt-head-left' },
        { title: "Docs Signed", data: 'signed_on', className: 'dt-body-right dt-head-right' },
      ]
    } else if ($scope.displayMethod == 1) {
      columns = [
        { title: "DOC ID", data: 'id', className: 'dt-body-center dt-head-center' },
        { title: "County", data: 'county', className: 'dt-body-left dt-head-left' },
        { title: "CAD Account", data: 'cad_account', className: 'dt-body-right dt-head-right' },
        { title: "User ID", data: 'user_id', className: 'dt-body-right dt-head-right' },
        { title: "First Name", data: 'first_name', className: 'dt-body-left dt-head-left' },
        { title: "Last Name", data: 'last_name', className: 'dt-body-left dt-head-left' },
        { title: "Docs Signed", data: 'signed_on', className: 'dt-body-right dt-head-right' },
        { title: "Send to CAD", data: 'sent_to_cad_date', className: 'dt-body-right dt-head-right' },
      ]
    }

    /*
      The toolbar stacks on narrow screens, so it eats more vertical space and a
      fixed 410px offset leaves the grid only a sliver. Scale the reserved space
      to the breakpoint; the desktop value is unchanged.
    */
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth
    const scrollOffset = viewportWidth <= 768 ? 470 : viewportWidth <= 992 ? 440 : 410

    let config = {
      data: aoaData,
      scrollY: `calc(100vh - ${scrollOffset}px)`,
      scrollX: true,
      pagingType: 'full_numbers',
      dom: 'BQrtip',
      pageLength: 24,
      deferRender: true,
      select: true,
      lengthMenu: [
        [10, 24, 50, 100, -1],
        ['10 rows', '24 rows', '50 rows', '100 rows', 'Show all']
      ],
      buttons: [
        'pageLength', 'spacer', 'csv', 'excel', 'print',
        { extend: 'searchBuilder' }
      ],
      language: {
        searchBuilder: {
          button: 'Filter',
        }
      },
      columns: columns,
    }
    table = $(aoaTable).DataTable(config)
    table.draw()
    safeApply($scope)

  }

  $scope.processAOAs = async function () {
    let allRows = table.rows().data()
    let pdfs = [], csv = []
    let csv_filename
    $scope.records_to_update = []
    let request, end_point
    const timestamp = $filter('date')(new Date(), 'MM-dd-yy_HH-mm')

    const max_files = 100

    console.log('aoa_processing_method :>> ', aoa_processing_method);
    console.log('aoa_naming_convention :>> ', aoa_naming_convention);

    console.log('allRows :>> ', allRows);

    switch (aoa_processing_method) {

      // createZipFromPDFs API CALL
      case 'zip':
        for (var i = 0; i < Math.min(allRows.length, max_files); i++) {
          let row = allRows[i]

          let zip_filename = aoa_naming_convention.replace('%cad_account%', row.cad_account)
          zip_filename = zip_filename.replace('%agent_id%', agent_id)

          let obj = {
            type: "remote",
            pdf: row.doc_link_view,
            doc_type: "aoa",
            zipped_filename: zip_filename
          }
          pdfs.push(obj)
          csv.push({ "CAD Account": `"${row.cad_account}"`, "Situs": `"${row.situs}"`, "First Name": row.first_name, "Last Name": row.last_name, "Authorized": "", "Reason not Authorized": "" })
          $scope.records_to_update.push({ doc_id: row.id })
        }
        // console.log('pdfs :>> ', pdfs);
        $scope.file_count = i
        end_point = 'https://api.propertytax.io/pdf/createZipFromPDFs'
        // end_point = 'http://localhost:5050/pdf/createZipFromPDFs'
        csv_filename = `aoa_${$scope.currentCounty.cad_code}_${timestamp}.csv`
        request = {
          pdfs: pdfs,
          dest: {
            bucket: "propertytax",
            path: "aoa",
            filename: `aoa_${$scope.currentCounty.cad_code}_${timestamp}.zip`,
            metadata: { "CAD": $scope.currentCounty.cad_code }
          }
        }
        // console.log('request :>> ', request);
        break

      // mergePDFs API CALL
      case 'single_pdf':
        for (var i = 0; i < Math.min(allRows.length, max_files); i++) {
          let row = allRows[i]
          // console.log('row.id :>> ', row.id);
          if (row.doc_link_view != undefined || row.doc_link_view != null) {
            let obj = {
              type: "remote",
              pdf: row.doc_link_view
            }
            pdfs.push(obj)
            // csv.push({ "CAD Account": row.cad_account, "Situs": row.situs, "First Name": row.first_name, "Last Name": row.last_name, "Authorized": "", "Reason not Authorized": "" })
            $scope.records_to_update.push({ doc_id: row.id })
          }
        }
        $scope.file_count = i
        // console.log('pdfs :>> ', pdfs)
        end_point = 'https://api.propertytax.io/pdf/mergePDFs'
        // end_point = 'http://localhost:5050/pdf/mergePDFs'
        request = {
          "pdfs": pdfs,
          dest: {
            "bucket": "propertytax",
            "path": "aoa",
            "filename": `${$scope.currentCounty.cad_code}_${timestamp}.pdf`,
            "metadata": { "CAD": $scope.currentCounty.cad_code }
          }
        }
        console.log('request :>> ', request);
        break
    }

    let csvFile = null
    // Create CSV file for the AOA's in report
    if (aoa_processing_method == 'zip') {
      csvFile = convertToCSV(csv)
      console.log('csvFile :>> ', csvFile);
      console.log('csv_filename :>> ', csv_filename);
      // downloadCSV(csvContent = "data:text/csv;charset=utf-8," + csvFile, csv_filename)
    }

    let results = await aoaService.createFileByAPI({ end_point: end_point, request: { ...request, csv: { buffer: csvFile, filename: csv_filename } } })
    // console.log('results :>> ', results);
    // console.log('$scope_file_url :>> ', $scope_file_url);

    if (results.data.success) {
      $scope.file_url = results.data.data.download
    } else {
      $scope.file_url = null
    }

    downloadFile(request.dest.filename, $scope.file_url)
    var myModal = new bootstrap.Modal(document.getElementById(aoa_management_filelink_modal))
    myModal.show()
    safeApply($scope)
  }

  $scope.updateAOAStatus = async function () {
    console.log('$scope.records_to_update :>> ', $scope.records_to_update);
    // Update documents to sent_to_cad = 1 and update sent_to_cad_date
    let results = await aoaService.updateDocumentRecords({ records: $scope.records_to_update })
    console.log('results :>> ', results);
    init()
    safeApply($scope)
  }

  function downloadFile(filename, dataUrl) {
    let link = document.createElement("a")
    link.download = filename
    link.target = "_blank"
    link.href = dataUrl
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    delete link
  }

  function downloadCSV(csvContent, csvFile) {
    var encodedUri = encodeURI(csvContent)
    var link = document.createElement("a")
    link.target = "_blank"
    link.setAttribute("href", encodedUri)
    link.setAttribute("download", csvFile)
    document.body.appendChild(link)
    link.click()
  }

  function convertToCSV(arr) {
    const array = [Object.keys(arr[0])].concat(arr)
    return array.map(it => {
      return Object.values(it).toString()
    }).join('\n')
  }

})